import { Image, Text, VStack } from 'native-base';
import { ChangeEvent, ForwardedRef } from 'react';
import UpdateProfileImage from 'ui/assets/images/updateProfile.png';
import Button from 'ui/components/Button';
import Modal from 'ui/components/Modals/Modal';
import { IModalRefProps } from 'ui/components/Modals/Modal/types';
import { colors } from 'ui/theme/colors';

interface PreferencesModalProps {
  onPressButton: () => void;
  modalRef?: ForwardedRef<IModalRefProps>;
}

export const PreferencesModal = ({
  modalRef,
  onPressButton,
}: PreferencesModalProps) => {
  return (
    <Modal
      modalContentMaxW={{ base: '100vw', lg: '720' }}
      modalContentMaxH={{ base: '100vh', lg: 'auto' }}
      modalContentW={{ base: '100vw', lg: '720' }}
      modalContentH={{ base: '100vh', lg: 'auto' }}
      p={0}
      ref={modalRef}
      hideCloseBtn
      closeOnOverlayClick={false}
      onClose={(e: ChangeEvent<HTMLInputElement>) => e.preventDefault()}
    >
      <VStack
        h={{ base: '85vh', md: 'auto' }}
        py="2"
        space={4}
        justifyContent="space-between"
        alignItems="center"
      >
        <Image
          source={{
            uri: UpdateProfileImage,
          }}
          w={{ base: '100%', lg: '696px' }}
          h={{ base: '250px', lg: '320px' }}
        />

        <Text
          color={colors.singletons.black}
          fontSize={{ base: 'md', lg: '3xl' }}
          fontWeight={500}
        >
          Let’s get you set up!
        </Text>
        <Text
          fontSize={{ base: 'sm', lg: 'md' }}
          textAlign={{ base: 'left', lg: 'center' }}
          fontWeight={400}
        >
          To find the best volunteering opportunities for you, take a minute to
          update your profile. Add <strong>your location</strong> so we can
          match you with nearby activities, <strong>your skills</strong> so we
          can recommend where you can shine.
        </Text>
        <Button width={{ base: '100%', lg: '320px' }} onPress={onPressButton}>
          Update my profile
        </Button>
      </VStack>
    </Modal>
  );
};
